import React, { PureComponent } from 'react';
import * as d3 from 'd3';
import * as dl from 'datalib';
import * as _ from 'lodash';
import { permutations } from 'itertools';
import { networkCTN } from '../../common/vega/VegaSpecifications';
import Preloader from '../../components/Preloader';
import VegaChart from '../../common/vega/VegaChart';
import { Grid } from 'semantic-ui-react';
import { CSVLink } from "react-csv";
import {strings} from '../../common/translations'
import {LANG} from '../../common/constants'

class DataVizNetworkCTN extends PureComponent {
    constructor() {
        super()
        this.state = {};
    }


    componentDidMount() {

        // Translate legend titles
        networkCTN["legends"][0]["title"] = strings.RETI_COLLABORAZIONE.CHARTS.NETWORK_CTN.LEGENDS.COLOR_TITLE;
        networkCTN["legends"][1]["title"] = strings.RETI_COLLABORAZIONE.CHARTS.NETWORK_CTN.LEGENDS.SHAPE_TITLE;

        // Translate legend origin labels
        networkCTN["data"][0]["transform"][0]["expr"] = "datum.nuts2Description === 'Toscana' ? 'Toscana' : '" + strings.RETI_COLLABORAZIONE.CHARTS.NETWORK_CTN.LEGENDS.OUTSIDE_LABEL + "' ";
        networkCTN["data"][2]["transform"][1]["expr"] = "datum.nuts2Description === 'Toscana' ? 'Toscana' : '" + strings.RETI_COLLABORAZIONE.CHARTS.NETWORK_CTN.LEGENDS.OUTSIDE_LABEL + "' ";

        d3.csv('data/collaboration_network_CTN_funding_' + LANG + '.csv')
            .then(data => {  
                
                // get unique Tuscany org.
                const tuscanyOrgs = _.uniqBy(data, 'tuscan_inst').map( o => {
                    return {
                        name: o.tuscan_inst,
                        nuts2: 'ITI1',
                        nuts2Description: 'Toscana'
                    }
                });

                // get unique non-Tuscany orgs.
                const partnerOrgs = _.uniqBy(data, 'partner').map( o => {
                    return {
                        name: o.partner,
                        nuts2: o.partner_nuts2,
                        nuts2Description: o.partner_nuts_2_description
                    };
                });

                // join all orgs and assign unique ID
                const allOrgs = _.concat(tuscanyOrgs, partnerOrgs).map( (o, index) => {
                    return _.set(o, 'index', index)
                })

                // group by project 
                const projects = dl.groupby(["project_code"]).execute(data);

                // generate all possible collaborations for each project
                let allCollaborations = [];
                projects.forEach( project => {
                    const participants = _.uniq(
                        _.concat(
                            _.map(_.uniqBy(project.values, 'tuscan_inst'), 'tuscan_inst'),
                            _.map(_.uniqBy(project.values, 'partner'), 'partner')
                        )
                    );
                    let permutedParticipants = Array.from(
                        permutations(participants, 2)
                    );
                    permutedParticipants.sector = _.first(project.values).sector_1;
                    allCollaborations.push(permutedParticipants);
                });

                // remove those combinations with same name
                allCollaborations = _.chain(allCollaborations)
                    .map( arr => {
                        return arr.map( collab => {
                            return {
                                source: _.find(allOrgs, ['name', collab[0]]).index,
                                target: _.find(allOrgs, ['name', collab[1]]).index,
                                sector: arr.sector
                            };
                        })                        
                    })
                    .flatten()
                    .filter( o => o.source !== o.target)
                    .value();

                // generate edges
                allCollaborations = dl
                    .groupby(['source', 'target', 'sector'])
                    .count()
                    .execute(allCollaborations)

                // add to each node its number of edges (so it can
                // be sized by its connections)
                allOrgs.forEach( org => {
                    org.edges = _.filter(
                        allCollaborations,
                        collab => collab.source === org.index || collab.target === org.index
                    ).length;
                })

                this.setState({ allOrgs, allCollaborations, data });                
            });
    }



    render() {
        const {allOrgs, allCollaborations, data} = this.state;

        if(allOrgs && allCollaborations) 
            return <Grid>
                <Grid.Row>
                    <Grid.Column>
                    <VegaChart
                        chartClass={'dataviz-network-ctn'}
                        autoSize={'none'}
                        height={900}
                        dataDefs={[
                            {
                                name: 'node-data',
                                values: allOrgs
                            },
                            {
                                name: 'link-data',
                                values: allCollaborations
                            }
                        ]}
                        spec={networkCTN}
                        />
                        </Grid.Column>  
                </Grid.Row>
            <Grid.Row className="border-top">
                <Grid.Column width={16} className="d-flex flex-wrap">
                    <CSVLink data={data} 
                            className="ui red circular icon button mx-auto"
                            filename={"collaborazioneCTN.csv"}>
                                <i aria-hidden="true" className="download icon"></i>
                    </CSVLink>
                </Grid.Column>
            </Grid.Row>
                </Grid>
        else
            return <Preloader message="Caricando i dati" />
    }
}

export default DataVizNetworkCTN;
